import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { stepService } from '@/services/stepService';

export const useSteps = (tutorialId: string | number | undefined) => {
  return useQuery({
    queryKey: ['steps', tutorialId],
    queryFn: () => stepService.list(tutorialId!),
    enabled: !!tutorialId,
    staleTime: 2 * 60 * 1000,
  });
};

export const useCreateStep = (tutorialId: string | number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => stepService.create(tutorialId!, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['steps', tutorialId] });
      queryClient.invalidateQueries({ queryKey: ['tutorial', tutorialId] });
    },
  });
};

export const useUpdateStep = (tutorialId: string | number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ stepId, data }: { stepId: string | number; data: Record<string, unknown> }) =>
      stepService.update(tutorialId!, stepId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['steps', tutorialId] });
      queryClient.invalidateQueries({ queryKey: ['tutorial', tutorialId] });
    },
  });
};

export const useDeleteStep = (tutorialId: string | number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (stepId: string | number) => stepService.delete(tutorialId!, stepId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['steps', tutorialId] });
      queryClient.invalidateQueries({ queryKey: ['tutorial', tutorialId] });
    },
  });
};

export const useReorderSteps = (tutorialId: string | number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (stepIds: (string | number)[]) => stepService.reorder(tutorialId!, stepIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['steps', tutorialId] });
      queryClient.invalidateQueries({ queryKey: ['tutorial', tutorialId] });
    },
  });
};
